import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('pawnItemTypeCache', (http, CacheFactory, config) =>
  new LocalCache({
    provider: () => http.get('/products/pawns/items/types'),
    cacheFactory: CacheFactory,
    cacheTime: config.cache.pawnItemTypes,
    cacheName: 'pawnItemTypes'
  }));
